import React, { useEffect } from "react"
import { Box, Typography } from "@mui/material"
import { dsColorNew } from '@palette'
import { dsRepricingDrawerData, dsRepricingDrawerErrors } from "Pages/DsRepricing/Page/@signals"
import RangeList from "Pages/DsRepricing/Page/@components/RangeList"

// Durations are LOR (Length Of Rental) windows in days. Both bounds inclusive.
export default function DsRepricingDurations() {
	const durations = dsRepricingDrawerData.value.durations ?? []
	const isValid = durations.length > 0

	useEffect(() => {
		dsRepricingDrawerErrors.value = { ...dsRepricingDrawerErrors.value, durations: isValid }
	}, [isValid])

	return (
		<Box>
			<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 600 }}>
				Duration ranges (LOR)
			</Typography>
			<Typography component="span" sx={{ fontSize: 12, color: dsColorNew.textMuted, display: 'block', mb: 1 }}>
				The rental lengths this rule applies to, in days.
			</Typography>
			<RangeList
				values={durations}
				onChange={next => {
					dsRepricingDrawerData.value = { ...dsRepricingDrawerData.value, durations: next }
				}}
				// The rental lengths a price list is normally cut on.
				// `180` is the upper bound of the field, so the last
				// bracket of a ladder means "and everything longer".
				presets={{
					ladders: [
						{ label: 'Standard', ranges: [[1, 3], [4, 7], [8, 14], [15, 180]] },
						{ label: 'Short / long', ranges: [[1, 7], [8, 180]] },
					],
					singles: [[1, 3], [4, 7], [8, 14], [15, 30], [31, 180]],
				}}
				fromKey="durationFrom" toKey="durationTo"
				fromPlaceholder="1" toPlaceholder="7"
				minValue={1} maxValue={180}
				unitSuffix="days"
				addLabel="Add duration"
				overlapsExisting={(existing, from, to) =>
					existing.some(d => from <= d.durationTo && d.durationFrom <= to)}
				overlapError="Overlaps with an existing duration range"
				emptyError="Add at least one duration"/>
		</Box>
	)
}
